import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import type { WorkspaceConfig } from 'hb-react/backoffice/components/PageBuilder/types/workspaceConfig';
import type { SectionItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/sectionItemAttributes';

const DEFAULT_RECO_WIDTH = '100%';
const DEFAULT_RECO_PX = '0px';

interface WidthContentBoxProps {
  attributes?: SectionItemAttributes;
  children: ReactNode;
  height?: string | number;
  overflow?: string;
  width?: string | number;
  workspaceConfig: WorkspaceConfig;
}

const WidthContentBox = ({
  attributes,
  children,
  overflow,
  height,
  width,
  workspaceConfig,
}: WidthContentBoxProps) => {
  const recoWidth = workspaceConfig.contentWidth ?? DEFAULT_RECO_WIDTH;
  const recoPadding = workspaceConfig.horizontalPadding ?? DEFAULT_RECO_PX;

  const isBgVideoFullWidth =
    attributes?.backgroundType === 'video' && attributes?.fullWidth;

  return (
    <Wrapper
      data-testid="width-content-box"
      $height={height}
      $overflow={overflow}
      px={
        width !== 'auto' || isBgVideoFullWidth ? DEFAULT_RECO_PX : recoPadding
      }
      width={
        width !== 'auto' || isBgVideoFullWidth ? DEFAULT_RECO_WIDTH : recoWidth
      }
    >
      {children}
    </Wrapper>
  );
};

export default WidthContentBox;

interface WrapperProps {
  $height?: WidthContentBoxProps['height'];
  $overflow: WidthContentBoxProps['overflow'];
}

const Wrapper = styled(Box).attrs<WrapperProps>(({ $height }) => ({
  display: 'block',
  margin: '0 auto',
  height: $height || '100%',
}))<WrapperProps>`
  ${({ $overflow }) => $overflow && `overflow: ${$overflow};`}
`;
